import { formApi } from '../index';
import { CalculatePriceT } from '../../../../@types/calculatePrice.type';
import { SimpleOrdersT } from '../../../../features/orderForm/stepSummary/types/stepSummary.type';

export type CalculatePriceRequestT = {
  promoCodes: Array<string> | null;
  simpleOrders: Array<
    Omit<
      SimpleOrdersT,
      'addressId' | 'profileAddressId' | 'invoice' | 'note' | 'hourPreference'
    >
  >;
  loyaltyProgramPoints: number;
  loyaltyProgramPointsGlobal: number;
  companyId: string;
  calculation: CalculatePriceT;
  cityId: number;
};

export const shoppingCart = formApi.injectEndpoints({
  endpoints: build => ({
    postOpenOrder: build.mutation({
      query: body => ({
        method: 'POST',
        url: 'form/open/shopping-cart/order',
        body,
        headers: {
          'company-id': body.companyId,
        },
      }),
    }),
    // @ts-ignore
    postProfileOrder: build.mutation({
      query: body => ({
        method: 'POST',
        url: 'form/profile/shopping-cart/order',
        body,
        headers: {
          'company-id': body.companyId,
        },
      }),
    }),
    getOpenCalculatePrice: build.query<CalculatePriceT, CalculatePriceRequestT>(
      {
        query: body => ({
          method: 'POST',
          url: 'form/open/shopping-cart/calculate-price',
          body,
          headers: {
            'company-id': body.companyId,
          },
        }),
        keepUnusedDataFor: 3600,
      }
    ),
    getProfileCalculatePrice: build.query<
      CalculatePriceT,
      CalculatePriceRequestT
    >({
      query: body => ({
        method: 'POST',
        url: 'form/profile/shopping-cart/calculate-price',
        body,
        headers: {
          'company-id': body.companyId,
        },
      }),
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const {
  useGetOpenCalculatePriceQuery,
  useGetProfileCalculatePriceQuery,
} = shoppingCart;

export const { postOpenOrder, postProfileOrder } = shoppingCart.endpoints;
